import _ from 'lodash'

export default ({ currentUser: { gateways }, gatewayIdKey }) => ({
  item: { [gatewayIdKey]: gatewayId },
}) => {
  if (gatewayId === null) return false

  return !_.some(gateways, { id: gatewayId })
}
